import { useContext, useEffect } from 'react';

// Components
import { Aside } from '@/components/Aside/Aside';
import { Layout } from '@/components/Layout/Layout';
import { Main } from '@/components/Main/Main';
import { More } from '@/components/More/More';
import { Product } from '@/components/Product/Product';
import { Section } from '@/components/Section/Section';
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
import { usePiano } from '@/lib/hooks';

/**
 * ProductPage component
 * @returns {ReactElement}
 */
const ProductPage = () => {
  usePiano();
  const [ state, dispatch ] = useContext(Context);

  useEffect(() => {
    dispatch({
      type: ActionTypes.setCurrentPage,
      payload: {
        key: 'currentPage',
        value: 'productPage'
      }
    });

    dispatch({
      type: ActionTypes.showProductOnRight,
      payload: false
    });
  }, [ dispatch ]);

  return (
    <Layout className="layout-fullpage">
      <Main>
        <Section className={`section-product section-${state.productClass}`}>
          <Product />
        </Section>
      </Main>

      <div className="landingpage"></div>

      <Aside>
        <div className="aside--content">
          <div className="aside--contents">
            <More />
          </div>
        </div>
      </Aside>
    </Layout>
  );
};

export default ProductPage;
